import ActionButtons from '@components/Buttons/ActionButtons'
import { ContainedButtonVariant } from '@components/Buttons/ContainedButton'
import CircleIcon from '@mui/icons-material/Circle'
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import BasicModal from './BasicModal'

type LicenseFeesNoticeModalProps = {
  onAccept: () => void
}

export const LicenseFeesNoticeModal: React.FC<LicenseFeesNoticeModalProps> = ({
  onAccept,
}) => {
  const { t } = useTranslation()

  const dialogContentListItems = [
    t(
      'Modals.LicenseFeesNoticeModal.LicenseAmountDue',
      'License amount due will increase once SEND is clicked'
    ),
    t(
      'Modals.LicenseFeesNoticeModal.PayAllApplicationAndTuition',
      'Pay all application and tuition related license fees within 2 weeks of receipt'
    ),
    t(
      'Modals.LicenseFeesNoticeModal.FinalPayment',
      'Final payment for all Semester 1 license fees is due 9/5'
    ),
  ]

  return (
    <BasicModal
      isOpen
      dialogTitle={t(
        'Modals.LicenseFeesNoticeModal.Title',
        'Please Remember!!'
      )}
      maxWidth={'xs'}
      handleFormSubmit={onAccept}
      dialogActions={
        <ActionButtons primaryButtonLabel={ContainedButtonVariant.Ok} />
      }
      dialogContent={
        <Box maxWidth={300} mx="auto" textAlign="center">
          <List>
            {dialogContentListItems.map((dialogContentListItem, index) => (
              <ListItem disablePadding disableGutters key={index}>
                <ListItemIcon sx={{ minWidth: 28 }}>
                  <CircleIcon sx={{ fontSize: 14 }} />
                </ListItemIcon>
                <ListItemText primary={dialogContentListItem} />
              </ListItem>
            ))}
          </List>
        </Box>
      }
    />
  )
}
